<div class="">
    <i18n-html-content-loader-control
        [filePostFix]="'cookie-policy'"></i18n-html-content-loader-control>
</div>
